module.exports = __webpack_public_path__ + "img/LDEvsAlamo.0a613a58.png";